/* eslint-disable @typescript-eslint/ban-types */ /* eslint-disable @typescript-eslint/no-explicit-any */ import { hash } from '../../../util';
import { VERSION } from '../../../version';
import { DEFAULT_PREFIX, DYNAMIC_LAYER, DYNAMIC_TOKEN_PREFIX } from './constants';
import { serialize } from './serialize';
import { createTokens } from './token';
import { createValue } from './value';
import { createVariants } from './variant';
function createCss(options) {
    const tokens = createTokens(options.tokens, {
        prefix: DYNAMIC_TOKEN_PREFIX
    });
    const css = (...properties)=>serialize(css, properties);
    css.configure = (opts = {})=>{
        const o = typeof opts === 'function' ? opts(css) : opts;
        return createCss({
            ...options,
            ...o,
            alias: {
                ...options.alias,
                ...o.alias
            },
            variants: {
                ...options.variants,
                ...o.variants
            },
            plugins: {
                ...options.plugins,
                ...o.plugins
            },
            tokens: {
                ...options.tokens,
                ...o.tokens
            }
        });
    };
    css.variants = createVariants('', options.variants, {
        cascading: true,
        prefix: options.prefix
    });
    css.hash = hash(JSON.stringify(options));
    css.options = options;
    css.value = (value)=>createValue(tokens, value);
    css.token = tokens;
    css[DYNAMIC_LAYER] = options.layer === DYNAMIC_LAYER ? css : createCss({
        ...options,
        layer: DYNAMIC_LAYER
    });
    return css;
}
export const css = createCss({
    alias: {},
    variants: {},
    layer: '',
    plugins: {},
    prefix: DEFAULT_PREFIX,
    tokens: {},
    version: VERSION
});

//# sourceMappingURL=css.js.map